// ============================================
// ALMACEN/KARDEX.JS — cada traspaso: de donde, a donde, quien, cuando, cantidad (SUB-ALMACENES H, 2026-10-19)
// ============================================
// Lee GET /api/inventario/kardex con el filtro que le den (producto, sub-almacen, herramienta, expediente). El costo con el
// que viajo cada pieza solo llega a quien ve costos (el servidor lo tapa; aqui se pinta si viene).
import React, { useEffect, useState } from 'react';
import { fetchAuth } from '../../utils/sesion';
import { API_BASE } from '../../config/api';
import { fmtDinero } from '../../utils/dinero';
import { C, PP, fmtCant, fmtFechaHora, unidadCorta } from './ui';

const ICONO = { central: '📦', oficina: '🏢', tecnico: '🪛', instalado: '📷' };
export function etiquetaLado(nombre, tipo) { return `${ICONO[tipo] || '↗'} ${nombre}`; }

export default function Kardex({ filtro, titulo = 'Kardex · cada traspaso', limite = 100, compacto = false, filas: filasDadas }) {
  const [filas, setFilas] = useState(filasDadas || []);
  const [cargando, setCargando] = useState(!filasDadas);
  const [error, setError] = useState('');
  const clave = JSON.stringify(filtro || {});
  useEffect(() => {
    if (filasDadas) { setFilas(filasDadas); return undefined; }
    let vivo = true; setCargando(true);
    const qs = new URLSearchParams({ ...(filtro || {}), limit: String(limite) }).toString();
    fetchAuth(`${API_BASE}/api/inventario/kardex?${qs}`).then(r => r.json()).then(d => { if (!vivo) return; if (d.ok) { setFilas(d.kardex || []); setError(''); } else setError(d.error || 'Error'); })
      .catch(e => { if (vivo && e.code !== 'SESION_EXPIRADA') setError(e.message); }).finally(() => vivo && setCargando(false));
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clave, limite, filasDadas]);

  return (
    <div style={{ fontFamily: PP }}>
      {titulo && <div style={{ fontSize: 11, color: C.grisClaro, fontWeight: 700, textTransform: 'uppercase', marginBottom: 6 }}>{titulo}</div>}
      {error && <div style={{ color: C.rojo, fontSize: 12 }}>⚠️ {error}</div>}
      {cargando && filas.length === 0 && <div style={{ color: C.grisClaro, fontSize: 12 }}>Cargando…</div>}
      {!cargando && filas.length === 0 && !error && <div style={{ color: C.grisClaro, fontSize: 12 }}>Sin movimientos todavía.</div>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {filas.map(k => (
          <div key={k.id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: compacto ? 11.5 : 12, color: C.gris, padding: '6px 8px', background: '#fafbfc', borderRadius: 8, flexWrap: 'wrap' }}>
            <span style={{ color: C.grisClaro, flexShrink: 0, minWidth: 92 }}>{fmtFechaHora(k.creado_en)}</span>
            <span style={{ flex: 1, minWidth: 180 }}>
              <strong>{fmtCant(k.cantidad)} {k.herramienta_id ? '' : unidadCorta(k.unidad)}</strong>{' '}
              {k.herramienta_id ? <>{k.herramienta_nombre} <span style={{ color: C.grisClaro }}>({k.numero_activo})</span></> : (k.producto_modelo || k.producto_nombre)}
              {' '}<span style={{ color: C.grisClaro }}>·</span> {etiquetaLado(k.de_nombre, k.de_tipo)} <span style={{ color: C.principal, fontWeight: 700 }}>→</span> {etiquetaLado(k.a_nombre, k.a_tipo)}
              {k.expediente_folio ? <span style={{ color: C.oscuro, fontWeight: 700 }}> · {k.expediente_folio}</span> : null}
              {k.consumido_por_nombre ? <span style={{ color: C.ambar }}> · consumió {k.consumido_por_nombre}</span> : null}
              {k.quien ? <span style={{ color: C.grisClaro }}> · por {k.quien}</span> : null}
              {k.costo_unitario != null && !k.herramienta_id ? <span style={{ color: C.grisClaro }}> · a {fmtDinero(k.costo_unitario)} c/u</span> : null}
              {k.nota ? <span style={{ color: C.grisClaro, fontStyle: 'italic' }}> · {k.nota}</span> : null}
            </span>
            <span style={{ fontSize: 10.5, color: C.grisClaro, flexShrink: 0 }}>{k.motivo}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
